define([
    "./revisionModule",
    "./revisionService",
    "./nlgRevisionTable"
], function () {});